import { useAnalytics } from "@lazarentertainment/analytics-collector"
import { FeaturedProductButton } from "client/packages/commerce/components/product/FeaturedProductButton"
import {
  Plugin,
  useGlobalContext,
} from "client/packages/utils/GlobalContext"
import { useCallback } from "react"

import { useChannelContext } from "../../../components/channel"
import { useFeaturedProduct } from "../hooks/useFeaturedProduct"

import { TargetView, useTargetContext } from "./TargetContext"

// Wrapper for the FeaturedProductButton, specifically for Target
// Handles data/logic, not UI:
// - Determining the featured product
// - Whether the FeaturedProductButton should be shown
// - What to do when the featured product button is pressed
export const TargetFeaturedProductButton = () => {
  const { analytics } = useAnalytics()
  const { channelId, broadcastId, recordingId } = useChannelContext()

  const {
    state: { isTargetPluginAvailable },
    setPluginOpen,
  } = useGlobalContext()
  const {
    setCurrentlySelectedProductId,
    setView,
    setShowImageGallery,
    setAddedProduct,
  } = useTargetContext()
  const { product: featuredProduct } = useFeaturedProduct()

  const onFeaturedTargetProductButtonClick = useCallback(() => {
    if (!featuredProduct) {
      return
    }
    analytics.track("target_featured_popup", {
      channelId,
      broadcastId,
      recordingId,
      productId: featuredProduct.id,
    })
    setView(TargetView.PRODUCT)
    setCurrentlySelectedProductId(featuredProduct.id)
    setPluginOpen(Plugin.TARGET, true)
    setShowImageGallery(false)
    setAddedProduct(null)
  }, [featuredProduct, setPluginOpen, setCurrentlySelectedProductId])

  const shouldShow = isTargetPluginAvailable && featuredProduct

  return (
    <FeaturedProductButton
      onClick={onFeaturedTargetProductButtonClick}
      product={
        shouldShow
          ? {
              id: featuredProduct.id,
              title: featuredProduct.title,
              priceAmount: featuredProduct.preselectedVariant.price,
              currencyCode: "USD",
              displayCurrencyCode: false,
              imageSrc:
                featuredProduct.preselectedVariant.featuredImage?.url,
            }
          : undefined
      }
    />
  )
}
